const productSettings = {
  pageTitle: "Lappa settings",
  backToSettings: "Settings",
  pageHelmetTitle: "Billing history",
  pageTitles: {
    applications: "Applications",
    billings: "Billings",
    plansAndUsage: "Plans & Consumption",
    payments: "Payments",
    sandbox: "Sandbox",
  },
  customerBillingNote:
    "Only your business billing data is shown here (not customer documents).",
  billingDecimalSeparatorHint:
    "Use a dot (.) as the decimal separator, for example 1250.50.",
  mainTabs: {
    applications: "Applications",
    billingHistory: "Billing history",
    plansAndUsage: "Plans & Consumption",
    payments: "Payments",
    sandbox: "Sandbox",
  },
  sandbox: {
    cancel: "Cancel",
    navigation: {
      switchTo: "Switch to sandbox",
      currentSandbox: "Sandbox active",
      switchBack: "Switch back to live company",
      active: "Active sandbox",
      open: "Switch to this sandbox",
      empty: "No sandbox has been created yet.",
      create: "Create sandbox",
      manage: "Manage sandboxes",
      singleLimit: "Only one sandbox can be created for a company.",
    },
    access: {
      title: "This feature is not available in Sandbox",
      disabledDescription:
        "Switch back to your live company to access this feature.",
      noPermission:
        "You don't have permission to use this feature in Sandbox.",
      disabledHint: "Not available in Sandbox",
    },
    create: {
      configurationTitle: "Starting configuration",
      configurationDescription: "Choose what to include in your new sandbox.",
      copyAccount: "Copy account",
      copyAccountDescription:
        "Settings and capabilities will be modeled after your live account.",
      newSandbox: "Create new sandbox",
      newSandboxDescription: "Nothing will be copied from your live account.",
      next: "Next",
      nameTitle: "Name sandbox",
      nameDescription:
        "We generated a name for you, but feel free to change it now or later.",
      nameLabel: "Sandbox name",
      nameRequired: "Enter a sandbox name.",
      nameTooLong: "Sandbox name must be 80 characters or fewer.",
      regenerate: "Regenerate",
      back: "Back",
      submit: "Create sandbox",
    },
    manage: {
      title: "Manage sandboxes",
      description:
        "Create an isolated environment for testing without changing your live company data.",
      emptyTitle: "No sandbox yet",
      emptyDescription:
        "Create a sandbox to safely test settings and workflows.",
      sandboxDescription: "Isolated from your live company data",
      delete: "Delete sandbox",
      deleteTitle: "Delete sandbox",
      deleteDescription:
        "This sandbox and all of its data will be permanently deleted. This action cannot be undone.",
      deleteActiveHint:
        "Switch back to your live company before deleting this sandbox.",
      created: "Sandbox created successfully.",
      deleted: "Sandbox deleted successfully.",
      retry: "Try again",
    },
  },
  plansAndUsage: {
    innerTabs: {
      overview: "Overview",
      usageAndLimits: "Consumption",
    },
    productFilters: {
      ariaLabel: "Product filter",
      ltax: "L'Tax",
      linvoice: "L'Invoice",
      lepr: "L'EPR",
      lauthorize: "L'Authorize",
      // Legacy key (British spelling) — keep for old sessionStorage / bookmarks
      lauthorise: "L'Authorize",
    },
    emptyProduct: "No active subscription for this product.",
    emptyProductHint: "Choose a plan to start using this product.",
    loading: "Loading plans…",
    subscriptionDrawer: {
      plan: "Plan",
      includedFeatures: "Included features",
      addons: "Add-ons",
      limits: "Limits",
      billing: "Billing",
      billingCycle: "Billing cycle",
      price: "Price",
      changePlan: "Change plan",
    },
    usagePlaceholder: "Consumption — coming soon.",
    usage: {
      periodSwitch: "Usage period",
      monthly: "Monthly",
      yearly: "Yearly",
      coreLimits: "Core limits",
      addonUsage: "Add-on usage",
      creditsTitle: "Credits",
      creditsSubtitle: "Shared across this project",
      remaining: "remaining",
      remainingValue: "{{value}} remaining",
      available: "available",
      used: "used",
      availableUsed: "{{available}} available • {{used}} used",
      percentUsed: "{{percent}}% used",
      footerResetDefault: "Consumption for current subscription period",
      metricSummary: "{{label}} — {{used}} of {{limit}} used ({{percent}}%)",
      daysToRenewal: "{{count}} days to renewal",
      manageSubscription: "Manage subscription",
    },
    overview: {
      subscriptionTitle: "Subscription",
      creditsTitle: "Credits",
      addonsTitle: "Add-ons",
      planDetailsTitle: "Plan details",
      activeBadge: "Active",
      inactiveBadge: "Inactive",
      nextBillingDate: "Next billing date",
      billingCycle: "Billing cycle",
      billingCycleYearly: "Yearly",
      billingCycleMonthly: "Monthly",
      perYear: "/ year",
      perMonth: "/ month",
      perMonthShort: "/mo",
      creditSingular: "credit",
      creditPlural: "credits",
      manageCredits: "Manage credits",
      subscriptionsTitle: "Subscriptions",
      primarySubscription: "Primary subscription",
      otherSubscriptions: "Other subscriptions",
      nextBillingShort: "Next billing",
      billingMetaTotal: "Total",
      billingMetaNextBilling: "Next billing",
      creditsProjectLevel: "Shared across this project",
      summaryProjectLevel: "Project-level totals",
      viewDetails: "View details",
      manageSubscription: "Manage subscription",
      changeSubscription: "Change subscription",
      upgradePlan: "Upgrade plan",
      choosePlan: "Choose plan",
      buyAddons: "Buy addons",
      cancelSubscription: "Cancel subscription",
      canceledStatus: "Canceled",
      planLabel: "Plan",
      statusLabel: "Status",
      priceLabel: "Price",
      createdLabel: "Created",
      includedCountries: "Included countries",
      includedUsers: "Included users",
      vatReturns: "VAT returns",
      statesIncluded: "States included",
      registrationsIncluded: "Registrations",
      autoFiling: "Auto filing",
      includedFeaturesTitle: "Included features",
      subscriptionDetailsTitle: "Subscription details",
      noAddons: "No add-ons on this subscription.",
      noAddonsConnected: "No add-ons",
      oneAddonConnected: "1 add-on connected",
      addonsConnected: "{{count}} add-ons connected",
    addonsColName: "",
    addonsColLimits: "Limits",
    addonsColPeriod: "Period",
    addonsColQuantity: "Quantity",
    addonsColPrice: "Price",
      summaryTitle: "Billing summary",
      monthlyTotal: "Monthly total",
      planCost: "Plan cost",
      addons: "Add-ons",
      addonsTotal: "Add-ons total",
      total: "Total",
    },
  },
  tabs: {
    proforma: "Proforma invoice",
    taxInvoice: "Tax Invoice",
    creditNote: "Credit Note",
    payments: "Payments",
    requestFunds: "Request funds",
    intermediaryPayments: "Intermediary payments",
    creditsSummary: "Credits summary",
  },
  intermediaryPayments: {
    toolbar: {
      create: "Add intermediary payment",
    },
    table: {
      fundRequest: "Request Funds",
      recipient: "Recipient",
      amount: "Amount",
      approval: "Approval",
      execution: "Execution",
      deadline: "Deadline",
      executor: "Executor",
      reference: "Payment ref.",
    },
    filters: {
      approvalLabel: "Approval",
      executionLabel: "Execution",
      executorLabel: "Executor",
      overdueLabel: "Deadline",
      approvalAll: "All approvals",
      executionAll: "All execution",
      executorAll: "All executors",
      unassigned: "Unassigned",
    },
    approvalStatus: {
      draft: "Draft",
      pending: "Awaiting approval",
      approved: "Approved",
      returned: "Returned",
      rejected: "Rejected",
      cancelled: "Cancelled",
    },
    executionStatus: {
      not_started: "Not started",
      ready: "Ready to pay",
      in_progress: "With executor",
      executed: "Paid",
      failed: "Payment failed",
      unknown: "Outcome unknown",
      returned: "Returned by executor",
    },
    empty: {
      title: "No intermediary payments",
      description:
        "When managers create payments against fund requests, they will appear here for approval and execution.",
      filteredTitle: "No matching intermediary payments",
      filteredDescription:
        "No intermediary payments match the selected filters. Try adjusting your filters.",
    },
    rowActions: {
      returnForRevision: "Return for revision",
    },
    lifecycle: {
      submitSuccess: "Intermediary payment submitted for approval.",
      approveSuccess: "Intermediary payment approved.",
      returnSuccess: "Intermediary payment returned for revision.",
      rejectSuccess: "Intermediary payment rejected.",
      takeSuccess: "Intermediary payment taken for execution.",
      executeSuccess: "Execution result recorded.",
      proofUploadSuccess: "Payment proof uploaded.",
      creditCheckSuccess: "Recipient credit check completed.",
      closeSuccess: "Intermediary payment closed.",
      deleteSuccess: "Intermediary payment deleted.",
      cancelSuccess: "Intermediary payment cancelled.",
      executorReturnSuccess: "Payment returned to the execution queue.",
    },
    proof: {
      heading: "Payment proof",
      hint: "Upload proof of payment for this transfer.",
      fileLabel: "Proof file",
      submit: "Upload proof",
      uploading: "Uploading…",
      fileRequired: "Select a file to upload.",
      modalTitle: "Upload payment proof",
      modalUpload: "Upload",
      modalCancel: "Cancel",
    },
    modal: {
      approveTitle: "Approve payment?",
      approveBody: "Approve this payment for execution.",
      approveConfirm: "Approve",
      returnApprovalTitle: "Return for revision?",
      returnApprovalBody:
        "Explain what needs to change before this payment can be approved.",
      returnConfirm: "Return",
      rejectTitle: "Reject payment?",
      rejectBody: "The payment will not be executed. Add a short reason for the team.",
      rejectConfirm: "Reject",
      commentLabel: "Comment",
      commentRequired: "Enter a comment.",
      submitTitle: "Submit for approval?",
      submitBody:
        "Send this payment to the approval queue. You will not be able to edit it until it is returned.",
      submitConfirm: "Submit",
      takeTitle: "Take for execution?",
      takeBody: "Assign this payment to you for execution.",
      takeConfirm: "Take",
      creditCheckTitle: "Complete recipient credit check?",
      creditCheckBody:
        "Record that the required recipient credit check has been completed for this payment.",
      creditCheckConfirm: "Confirm check",
      creditCheckCancel: "Cancel",
      closeTitle: "Close this payment?",
      closeBody:
        "This finalizes the payment. No further actions will be available after closing.",
      closeConfirm: "Close payment",
      closeCancel: "Cancel",
      deleteTitle: "Delete intermediary payment?",
      deleteBody:
        "Are you sure you want to delete this intermediary payment? This action cannot be undone.",
      deleteConfirm: "Delete",
      deleteCancel: "Cancel",
      cancelTitle: "Cancel this payment?",
      cancelBody: "The payment will be marked as cancelled and will not be executed.",
      cancelConfirm: "Cancel payment",
      cancelDismiss: "Keep payment",
      executorReturnTitle: "Return payment to queue?",
      executorReturnBody:
        "Release this payment so another executor can take it. Add a short note for the team.",
      executorReturnConfirm: "Return to queue",
      executorReturnCancel: "Cancel",
      executeTitle: "Record execution result",
      executeBody: "Record how this payment was executed.",
      executeConfirm: "Record result",
      executeCancel: "Cancel",
      executeResultLabel: "Result",
      executeResultPlaceholder: "Select result",
      executeResultRequired: "Select an execution result.",
      executeResultTransferred: "Transferred",
      executeResultPaymentError: "Payment error",
      executeResultOutcomeUnknown: "Outcome unknown",
      executeResultPaymentReturned: "Payment returned",
      executeActualAmountLabel: "Actual amount",
      executeActualDateLabel: "Actual date",
      executeActualDatePlaceholder: "Select date",
      executeBankReferenceLabel: "Bank operation reference",
    },
    actions: {
      edit: "Edit",
      submit: "Submit for approval",
      delete: "Delete",
      cancel: "Cancel payment",
      approve: "Approve",
      return: "Return",
      reject: "Reject",
      take: "Take for execution",
      execute: "Add execution result",
      recordPaymentReturn: "Record payment return",
      executorReturn: "Return to queue",
      uploadProof: "Upload proof",
      creditCheck: "Credit check",
      completeCreditCheck: "Complete credit check",
      close: "Close",
      closePayment: "Close payment",
    },
    wizard: {
      createTitle: "Create intermediary payment",
      createSubtitle:
        "Prepare an intermediary payment against a request of funds. Complete each step before saving a draft.",
      backToList: "Intermediary payments",
      fundRequestLabel: "Request of funds",
      fundRequestPlaceholder: "Select request of funds",
      fundRequestsUnavailable:
        "Fund requests for new intermediary payments are not available yet. Try again later.",
      rfNumber: "Number",
      availablePool: "Available pool",
      amountCurrencyHint: "Currency: {{currency}} (from request of funds).",
      recipientReferenceHint:
        "Reference the recipient expects on the payment — not the bank wire reference.",
      executorLabel: "Executor",
      executorHint: "Optional for draft. Required before submit for approval.",
      creditCheckRequiredLabel: "Recipient credit check required",
      creditCheckRequiredCheckbox: "Require credit check before this payment can be closed",
      draftCreateSuccess: "Intermediary payment draft created successfully.",
      draftCreateError: "Could not save intermediary payment draft.",
      editTitle: "Edit intermediary payment",
      editSubtitle:
        "Update payment details and assignments. Only changed fields are sent to the server.",
      editApprovalWarning: "Editing certain fields may reset payment approval.",
      editSaveSuccess: "Intermediary payment updated successfully.",
      editSaveError: "Could not save intermediary payment changes.",
      errorFundRequestRequired: "Select a request of funds.",
      errorFundRequestPreselectInvalid:
        "The request of funds in the link is not available for a new payment.",
      errorAmountRequired: "Enter a positive amount with up to two decimal places.",
      errorRequisitesRequired: "Bank details are required.",
      errorRecipientReferenceRequired: "Recipient reference is required.",
      errorPurposeRequired: "Purpose is required.",
      steps: {
        payment_details: "Payment details",
        payment_detailsDescription:
          "Link to a request of funds and enter recipient payment information.",
        assignment: "Assignment & instructions",
        assignmentDescription: "Ownership, deadlines, and internal payment instructions.",
      },
    },
    form: {
      recipient: "Recipient",
      requisites: "Bank details",
      recipientReference: "Recipient reference",
      purpose: "Purpose",
      amount: "Amount",
      effectiveDeadline: "Deadline",
      instruction: "Payment instruction",
      save: "Save draft",
      saveChanges: "Save changes",
      errorRecipient: "Recipient is required.",
    },
    detail: {
      title: "Intermediary payment",
      notFound: "Payment not found.",
      back: "Intermediary payments",
      closed: "Closed",
      copy: "Copy",
      copyToClipboard: "Copy {{label}}",
      copiedToClipboard: "Copied {{label}}",
      documentKicker: "Payment to",
      documentTitle: "Payment instruction",
      documentAria: "Intermediary payment instruction document",
      bankingSection: "Banking information",
      totalPayment: "TOTAL PAYMENT",
      totalPaymentLabel: "Total payment",
      statusPanelTitle: "Status and ownership",
      workflowPanelTitle: "Workflow & activity",
      ownershipSectionTitle: "Ownership",
      approvalStatusSectionTitle: "Approval status",
      executionStatusSectionTitle: "Execution status",
      creditCheckRequiredBeforeClose:
        "Recipient credit check is required before closing this payment.",
      proofEmpty: "No proof attached",
      rejectedAt: "Rejected",
      creditCheckLabel: "Credit check",
      creditCheckBadgeRequired: "Required",
      paymentSection: "Payment information",
      assignmentSection: "Assignment",
      approvalSection: "Approval",
      executionSection: "Execution details",
      entitySection: "Entity and period",
      recipientSection: "Recipient & payment",
      scheduleSection: "Deadlines & ownership",
      instructionSection: "Instruction & execution",
      amount: "Amount",
      actualAmount: "Actual amount",
      paidFor: "Paid for",
      taxNumber: "Tax number",
      period: "Period",
      fundRequest: "Request Funds",
      submittedAt: "Submitted",
      approvedAt: "Approved",
      approver: "Approver",
      approvalComment: "Approval comment",
      executedOn: "Actual date",
      executedBy: "Executed by",
      bankReference: "Bank reference",
      proof: "Payment proof",
      proofView: "View",
      proofOpenAction: "Open payment proof",
      creditCheck: "Credit check status",
      creditCheckRequired: "Credit check required",
      creditCheckPassed: "Passed",
      creditCheckPending: "Not run",
      creditCheckRequiredPending: "Required — not completed",
      creditCheckRequiredLabel: "Credit check required",
      creditCheckAwaiting: "Awaiting check",
      creditCheckCompleted: "Completed",
      creditCheckStatusLabel: "Status",
      recipientCreditCheckTitle: "Recipient credit check",
      executionActivityTitle: "Execution activity",
      executionResultLabel: "Execution result",
      proofUploadedBy: "Proof uploaded by",
      proofUploadedAt: "Proof uploaded at",
      creditCheckNotRequired: "Not required",
      creditCheckedBy: "Credit checked by",
      creditCheckedAt: "Credit checked at",
      creditCheckStatus: "Status",
      progressAria: "Payment progress",
      createdAt: "Created",
      updatedAt: "Updated",
    },
  },
  proforma: {
    addonsLabel: "Add-ons:",
    viewPayment: "View",
  },
  filters: {
    searchPlaceholder: "Search",
    proformaSearchPlaceholder: "Search by invoice number or name",
    dateRangeLabel: "Date range",
    dateFrom: "From",
    dateTo: "To",
    sortByStatus: "Filter by status",
    sortByStatusPrefix: "Sort by status:",
    statusAll: "All",
    showAll: "Show all",
    appsPrefix: "Apps:",
    proformaStatusNew: "New",
    proformaStatusProcessed: "Processed",
    proformaStatusVoided: "Voided",
    proformaStatusRefund: "Refund",
    proformaStatusBalanceRefund: "Balance refund",
    proformaAppLTax: "L'Tax",
    proformaAppLEpr: "L'EPR",
    proformaAppLInvoice: "L'Invoice",
    proformaAppLAuthorize: "L'Authorize",
    advancedFiltersTrigger: "Advanced filters",
    advancedFiltersTitle: "Advanced filters",
    advanced: {
      subscriptionType: "Subscription type",
      subscriptionPlaceholder: "Select subscription",
      addons: "Add-ons",
      addonsPlaceholder: "Select add-ons",
      amount: "Amount",
      amountPlaceholder: "Enter amount",
      optionNone: "\u2014",
      addonMockReports: "Reporting",
      addonMockCompliance: "Compliance",
    },
  },
  filterTabs: {
    moreOptions: "More options",
  },
  statuses: {
    PAID: "Paid",
    PENDING: "Pending",
    OPEN: "Open",
    COMPLETED: "Completed",
    CLOSED: "Closed",
    FAILED: "Failed",
    CANCELLED: "Cancelled",
    paid: "Paid",
    due: "Due",
    credited: "Credited",
  },
  statusFilter: {
    ALL: "All",
    PAID: "Paid",
    PENDING: "Pending",
    OPEN: "Open",
    COMPLETED: "Completed",
    CLOSED: "Closed",
  },
  table: {
    created: "Created",
    invoiceName: "Invoice name",
    creditNoteName: "Credit note name",
    relatedInvoice: "Related invoice",
    number: "Number",
    billingPeriod: "Billing period",
    status: "Status",
    payment: "Payment",
    app: "App",
    amount: "Amount",
    actions: "Actions",
  },
  linkedProformaBanner: {
    label: "Related proforma invoice:",
  },
  linkedPaymentBanner: {
    label: "Related payment:",
  },
  linkedTaxInvoiceBanner: {
    label: "Related tax invoice:",
  },
  contextualPkBanner: {
    clearFilter: "Clear filter",
  },
  billingTableEmpty: {
    title: "No items found",
    proformaTitle: "No items found",
    proformaEmptyDescription: "You currently do not have Proforma invoices",
    requestFundsEmptyDescription: "You currently do not have request funds",
    emptyNoSearch: "You currently do not have {{entity}}.",
    noItemsToDisplay: "There are no items to display.",
    searchNoMatch: 'Your search "{{query}}" did not match any items.',
    filtersNoMatch: "No items match the selected filters.",
    clearSearch: "Clear search",
    clearFilters: "Clear filters",
    entities: {
      _default: "records for this tab",
      PROFORMA: "proforma invoices",
      TAX: "tax invoices",
      CREDIT_NOTE: "credit notes",
      PAYMENTS: "payments",
      REQUEST_FUNDS: "request funds",
      CREDITS_SUMMARY: "credits summary entries",
    },
  },
  loading: "Loading billing history…",
  error: "We could not load billing history. Please try again.",
  retry: "Retry",
  tabsCheckup: {
    noneAvailableTitle: "No billing history available",
    noneAvailableDescription:
      "There are no billing history sections available for this company yet.",
    errorTitle: "Could not load billing history",
    errorDescription:
      "We could not determine which sections are available. Please try again.",
  },
  billingRowActions: {
    viewDetails: "View details",
    view: "View",
    pay: "Pay",
    edit: "Edit",
    void: "Void",
    restore: "Restore",
    download: "Download",
    delete: "Delete",
  },
  taxDownload: {
    error: "Could not download the file. Please try again.",
  },
  proformaDownload: {
    error: "Could not download the file. Please try again.",
  },
  requestFundsDownload: {
    error: "Could not download the file. Please try again.",
  },
  rowActions: {
    download: "Download",
    view: "View details",
    copyNumber: "Copy invoice number",
  },
  requestFunds: {
    addRequestFunds: "Add request funds",
    create: {
      drawerTitle: "Add request funds",
      cancel: "Cancel",
      create: "Create",
      currencyLabel: "Currency",
      requestTypeLabel: "Request type",
      paymentPurposeLabel: "Payment purpose",
      dateLabel: "Date",
      datePlaceholder: "Select date",
      requestNumberLabel: "Request number",
      descriptionLabel: "Description",
      jurisdictionLabel: "Jurisdiction",
      jurisdictionPlaceholder: "Select jurisdiction",
      stateLabel: "State",
      provinceStateLabel: "Province / State",
      stateProvinceLabel: "State / Province",
      statePlaceholder: "Select state / province (optional)",
      stateLoadingPlaceholder: "Loading…",
      requestedAmountLabel: "Requested amount",
      receivedAmountLabel: "Received amount",
      balanceLabel: "Balance",
      statusLabel: "Status",
      statusPendingPayment: "Pending payment",
      statusReceived: "Received",
      statusCompleted: "Completed",
      errorGeneric: "Could not create request funds.",
      errorCurrencyRequired: "Select a currency.",
      errorRequestTypeRequired: "Select a request type.",
      errorDateRequired: "Select a date.",
      errorRequestNumberRequired: "Enter the request number.",
      errorDescriptionRequired: "Enter a description.",
      errorJurisdictionRequired: "Select a jurisdiction.",
      errorAmountRequired: "Enter the amount.",
      errorAmountInvalid: "Enter a valid number.",
      errorStatusRequired: "Select a status.",
      requestDetailsSection: "Request details",
      lineItemsSection: "Line items",
      paymentDetailsSection: "Payment details",
      lineItemDescriptionLabel: "Description",
      lineItemAmountLabel: "Amount",
      errorQuantityInvalid: "Enter a valid quantity.",
      errorUnitPriceRequired: "Enter the unit price.",
      addLineItem: "Add line item",
      addItem: "Add item",
      addToList: "Add to list",
      removeLineItem: "Remove line item",
      removeItem: "Remove",
      totalLabel: "Total",
      bankLabel: "Bank",
      bankPlaceholder: "Select bank",
      errorLineItemRequired: "Enter a description.",
      errorLineItemsRequired: "Add at least one line item.",
      errorBankRequired: "Select a bank.",
      additionalDetailsSection: "Additional details",
      clientPaymentDeadlineLabel: "Client payment deadline",
      clientPaymentDeadlinePlaceholder: "Select date",
      transferDeadlineLabel: "Transfer deadline",
      transferDeadlinePlaceholder: "Select date",
      responsibleLabel: "Responsible",
      responsiblePlaceholder: "Select manager",
      deputyLabel: "Deputy",
      deputyPlaceholder: "Select manager",
      periodLabel: "Period",
      purposeLabel: "Purpose",
      errorFundManagers: "Could not load fund managers.",
    },
    edit: {
      errorFieldCannotBeCleared: "This field can't be cleared.",
      errorGeneric: "Could not update request funds.",
    },
    wizard: {
      createTitle: "Create request of funds",
      editTitle: "Edit request of funds",
      createRequest: "Create request of funds",
      saveChanges: "Save changes",
      next: "Next",
      back: "Back",
      backToList: "Request funds",
      accessDenied: "You do not have access.",
      legacyClosed: "This request is closed.",
      steps: {
        general: "General information",
        generalDescription:
          "Payment purpose, currency, request number, date, and jurisdiction.",
        bank: "Bank details",
        bankDescription: "Select the bank account for this request.",
        line_items: "Line items",
        line_itemsDescription: "Add invoice-style line items and review the total.",
        details: "Request details",
        detailsDescription:
          "Deadlines, responsible party, period, and purpose.",
        detailsCreateDescription:
          "Deadlines, responsible party, period, and purpose.",
        supporting: "Supporting information",
        supportingDescription: "Description and supporting attachments.",
        supportingCreateDescription: "Description and supporting attachments.",
        review: "Review & submit",
        reviewDescription: "Review the information before creating your request.",
      },
      bank: {
        optionalNotice:
          "A bank account is optional for this payment purpose. You may continue without selecting one.",
        detailsCardTitle: "Bank account details",
        bankName: "Bank name",
        accountName: "Account name",
        iban: "IBAN",
        bicSwift: "BIC / SWIFT",
        accountNumber: "Account number",
        sortCode: "Sort code",
        branch: "Branch",
        bankIdentifier: "Bank identifier",
      },
      lineItems: {
        quantityLabel: "Qty",
        unitPriceLabel: "Unit price",
        subtitle: "Add the expenses covered by this request.",
        deleteRowLabel: "Delete line item",
        optionalNotice:
          "Line items are optional for this payment purpose. You may continue without adding rows.",
        addNewLine: "Add new line",
        emptyPlaceholder: "No line items yet. Click to add the first line item.",
        edit: "Edit",
        delete: "Delete",
        resourceSingular: "line item",
        resourcePlural: "line items",
      },
      supporting: {
        headingTooltip: "Visible for Lappa team only",
        descriptionPendingSave:
          "Changes to this field are not yet saved — pending backend support.",
        attachmentLabel: "Supporting file",
        selectFile: "Select file",
        replaceFile: "Replace",
        removeFile: "Remove",
        localFileNotUploaded: "Selected — not yet uploaded",
        downloadServerFile: "Download saved attachment",
        notApplicable: "Line items and bank are not required for this request type.",
      },
      reviewPreparedForReview: "Information prepared for review",
      reviewPreviewStatus: "Preview only · Document not yet generated",
      reviewDocumentTitleUpper: "Request of Funds",
      reviewContextTitle: "Request context",
      reviewPaymentDetailsTitle: "Payment details",
      reviewInternalTitle: "Internal information (managers only)",
      reviewAssignmentTitle: "Assignment",
      reviewBankTitle: "Bank details",
      submitBlocked: {
        title: "Submit is disabled until the following are resolved:",
        paymentPurpose:
          "Payment purpose must be Tax Payment or Deposit / Guarantee until the backend supports additional types.",
        lineItemQtyUnitPrice:
          "Line items must use quantity 1 with unit price equal to amount until the backend accepts quantity and unit price.",
        bankChange:
          "Bank account changes cannot be saved until the backend accepts data updates.",
        lineItemsChange:
          "Line item changes cannot be saved until the backend accepts data updates.",
        descriptionChange:
          "Description changes cannot be saved until the backend accepts description updates.",
        localFile:
          "Remove the locally selected file — file upload is not available yet.",
      },
      review: {
        documentTitle: "Request of Funds",
        requestNumber: "Request number",
        date: "Date",
        requestType: "Request type",
        currency: "Currency",
        jurisdiction: "Jurisdiction",
        requestDetails: "Request details",
        supportingInformation: "Supporting information",
        noLineItems: "No line items added.",
      },
      lineItemModal: {
        addTitle: "Add line item",
        editTitle: "Edit line item",
        cancel: "Cancel",
        add: "Add",
        save: "Save",
      },
      lineItemDelete: {
        title: "Delete line item?",
        description: "This line item will be removed from the request.",
        descriptionWithItem: "Are you sure you want to delete '{{description}}'?",
        cancel: "Cancel",
        confirm: "Delete",
      },
    },
    filters: {
      sortByStatusPrefix: "Sort by status:",
      overduePrefix: "Overdue:",
      overdueShowAll: "Show all",
      overdueOnly: "Overdue only",
    },
    table: {
      created: "Created",
      description: "Description",
      jurisdiction: "Jurisdiction",
      number: "Number",
      document: "Document",
      requested: "Requested",
      received: "Received",
      balance: "Balance",
      overdueBadge: "Overdue",
      legacyClosedBadge: "Legacy closed",
    },
    document: {
      noDocument: "No document",
      sentToClient: "Sent to client",
      notSent: "Not sent",
      sending: "Sending…",
      pdfLink: "PDF",
      hint: {
        noDocument: "No system document for this request",
        sent: "PDF emailed to company Owner/Finance users",
        notSent: "PDF has not been delivered to the client yet",
        sending: "Delivering PDF to client users",
      },
    },
    summary: {
      availableCaption: "Available",
    },
    detail: {
      title: "Request of Funds",
      backLabel: "Request Funds",
      createdPrefix: "Created",
      notFound: "Request not found.",
      document: {
        label: "Document",
        requestFile: "Request file",
      },
      overview: {
        heading: "Overview",
        number: "Number",
        description: "Description",
        jurisdiction: "Jurisdiction",
        created: "Created",
        requested: "Requested",
        received: "Received",
        balance: "Balance",
        shortfall: "Shortfall",
        overpayment: "Overpayment",
        basisFile: "Basis file",
        downloadBasisFile: "Download basis file",
        editAction: "Edit",
        deleteAction: "Delete",
      },
    },
  },
  clientPayments: {
    sectionTitle: "Client payments",
    confirmationFile: "View file",
    rowAction: "Client payments",
    viewRowAction: "View payments",
    drawerTitleManager: "Client payments",
    drawerTitleClient: "Payments",
    close: "Close",
    addPayment: "Add payment",
    empty: "No client payments yet.",
    list: {
      date: "Date",
      bankReference: "Bank reference",
      confirmation: "Confirmation",
      confirmationFile: "Confirmation file",
      amount: "Amount",
      status: "Status",
      actions: "Actions",
      void: "Void",
      voidPayment: "Void payment",
    },
    add: {
      title: "Add client payment",
      cancel: "Cancel",
      submit: "Add payment",
      amountLabel: "Amount",
      currencyLabel: "Currency",
      dateLabel: "Date",
      datePlaceholder: "Select date",
      bankReferenceLabel: "Bank reference (optional)",
      confirmationFileLabel: "Confirmation file (optional)",
      addFile: "Add file",
      replaceFile: "Replace file",
      removeFile: "Remove",
      errorGeneric: "Could not add client payment.",
      errorAmountRequired: "Enter an amount greater than zero.",
      errorCurrencyRequired: "Select a currency.",
      errorDateRequired: "Select a date.",
    },
    void: {
      title: "Void client payment?",
      description: "This payment will be marked as voided.",
      cancel: "Cancel",
      confirm: "Void payment",
      reasonLabel: "Reason",
      errorGeneric: "Could not void client payment.",
      errorReasonRequired: "Enter a reason.",
    },
  },
  payments: {
    table: {
      type: "Type",
      reference: "Reference",
      paymentMethod: "Payment Method",
    },
    filters: {
      sortByPaymentMethodPrefix: "Sort by payment method:",
      sortAll: "All",
      sortCard: "Card",
      sortBankTransfer: "Bank transfer",
    },
  },
  paymentsDetails: {
    status: "Status",
    created: "Created",
    number: "Number",
    paymentMethod: "Payment Method",
    amount: "Amount",
    total: "Total",
    sectionTitle: "Payment details",
    colItem: "Item",
    colQty: "Qty",
    colPrice: "Price",
    downloadPdf: "Download PDF",
  },
  paymentsDeleteModal: {
    title: "Delete payment?",
    description:
      "Are you sure you want to delete this payment? This action cannot be undone.",
    cancel: "Cancel",
    delete: "Delete",
  },
  paymentsEdit: {
    drawerTitle: "Edit payment",
    drawerTitleWithNumber: "Edit payment {{number}}",
    cancel: "Cancel",
    save: "Save",
    paymentDateLabel: "Created date",
    paymentDatePlaceholder: "Select payment date",
    paymentNumberLabel: "Payment number",
    pdfLabel: "PDF file",
    replaceFile: "Replace file",
    removeFile: "Remove",
    errorGeneric: "Could not save changes.",
    errorPaymentDateRequired: "Select the payment date.",
    errorNumberRequired: "Enter the payment number.",
    errorSumRequired: "Enter the amount.",
    errorSumInvalid: "Enter a valid amount.",
    errorMissingType: "Payment type is missing; cannot save.",
  },
  creditsSummary: {
    cards: {
      salesTaxAvailable: "Sales Tax credits available",
      salesListAvailable: "Sales list credits available",
    },
    filters: {
      sortByTypePrefix: "Sort by type:",
      sortAll: "All",
      sortSalesTax: "Sales Tax",
      sortSalesList: "Sales List",
    },
    table: {
      description: "Description",
      id: "ID",
      creditType: "Credit Type",
      creditsLeft: "Credits Left",
      amount: "Amount",
    },
  },
  taxInvoiceDetails: {
    status: "Status",
    invoiceDate: "Invoice Date",
    invoiceNumber: "Invoice Number",
    vatNumber: "VAT Number",
    sectionTitle: "Invoice details",
    colItem: "Item",
    colQty: "Qty",
    colPrice: "Price",
    total: "Total",
    downloadPdf: "Download PDF",
  },
  creditNoteDetails: {
    status: "Status",
    createdDate: "Created",
    number: "Number",
    relatedInvoice: "Related invoice",
    sectionTitle: "Credit note details",
    colItem: "Item",
    colQty: "Qty",
    colPrice: "Price",
    total: "Total",
    downloadPdf: "Download PDF",
  },
  proformaInvoiceDetails: {
    title: "Proforma invoice",
    titleWithNumber: "Proforma invoice {{number}}",
    app: "App",
    addonsHeading: "Add-ons",
    noInvoiceDetails: "No invoice details",
  },
  proformaDeleteModal: {
    title: "Delete proforma invoice",
    description:
      "This proforma invoice will be permanently deleted. This action cannot be undone.",
    descriptionWithNumber:
      "Proforma invoice {{number}} will be permanently deleted. This action cannot be undone.",
    cancel: "Cancel",
    delete: "Delete",
  },
  proformaVoidModal: {
    title: "Void proforma invoice?",
    description:
      "This action will mark the proforma invoice as voided. You can restore it later if needed.",
    descriptionWithNumber:
      "Proforma invoice {{number}} will be marked as voided. You can restore it later if needed.",
    cancel: "Cancel",
    void: "Void invoice",
    success: "Proforma invoice voided successfully.",
    errorGeneric: "Could not void this invoice. Please try again.",
  },
  proformaRestoreModal: {
    title: "Restore proforma invoice?",
    description:
      "This action will restore the proforma invoice and set its status back to New.",
    cancel: "Cancel",
    restore: "Restore invoice",
    success: "Proforma invoice restored successfully.",
    errorGeneric: "Could not restore this invoice. Please try again.",
  },
  proformaPayModal: {
    title: "Pay proforma invoice",
    description:
      "Do you want to pay proforma invoice {{number}} from {{date}} for {{amount}}?",
    numberFallback: "—",
    cancel: "Cancel",
    pay: "Pay",
    shopifyPay: "Buy now with Shopify Pay",
  },
  proformaInvoiceEdit: {
    drawerTitle: "Edit proforma invoice",
    cancel: "Cancel",
    save: "Save",
    pdfLabel: "PDF invoice",
    replaceFile: "Replace file",
    removeFile: "Remove",
    errorTitle: "Save failed",
    errorGeneric: "Could not save changes.",
    errorNumberRequired: "Enter the invoice number.",
    errorSumRequired: "Enter the amount.",
    errorSumInvalid: "Enter a valid amount.",
    errorPaymentDateRequired: "Select the payment date.",
    errorUploadAfterSave: "Invoice was saved but the PDF upload failed.",
    createdDateLabel: "Created date",
    createdDatePlaceholder: "Select created date",
    paymentDateLabel: "Payment date",
    paymentDatePlaceholder: "Select payment date",
  },
  mainTabSoon: "Coming soon",
  paymentsSettings: {
    paymentMethod: {
      title: "Payment method",
      subtitle: "This card is used for subscription billing.",
      cardType: "Card type",
      cardNumber: "Card number",
      expirationDate: "Expiration date",
      exp: "Exp",
      expShort: "Exp {{exp}}",
      expLabel: "Exp: {{exp}}",
      cardPreviewLabel: "Saved payment card",
      type: "Type",
      noCardDescription: "No payment method added",
      noCardFooter: "Add a card to enable subscription billing and automatic payments.",
      addCard: "Add card",
      changeCard: "Change card",
      removeCard: "Remove card",
      removeCardError: "Failed to remove card. Please try again.",
      removeCardModal: {
        title: "Remove payment card?",
        description: "This card will no longer be used for subscription billing.",
        confirm: "Remove card",
        cancel: "Cancel",
      },
    },
    priorityCurrency: {
      title: "Priority currency",
      subtitle: "Choose the currency used by default for billing and invoices.",
      saveFailed: "Failed to update priority currency. Please try again.",
    },
    billingContacts: {
      title: "Billing contacts",
      subtitle: "Contact details used on invoices and billing correspondence.",
      edit: "Edit",
      cancel: "Cancel",
      save: "Save",
      saving: "Saving…",
      saveFailed: "Failed to save billing contact. Please try again.",
      selectTaxNumberType: "Select type",
      selectCountry: "Select country",
      noCountries: "No countries found",
      companyName: "Company name",
      country: "Country",
      email: "Email",
      phone: "Phone",
      typeTaxNumber: "Tax number type",
      vatNumber: "Tax number",
      postcode: "Postcode",
      city: "City/Town",
      streetAddress: "Street address",
      address: "Address",
      fieldRequired: "This field is required",
    },
  },
};

export default productSettings;
